import { GettingStarted, Developing, Leading, Visionary } from './Svg'

const data = [
  {
    slug: `getting-started`,
    heading: `Getting Started`,
    summary: `Your data is fragmented, slow, and untrustworthy`,
    description: `Your data is fragmented, slow, and untrustworthy
    You have minimal customer data collection in place. As a result, running analyses to provide insight into your customers and personalizing your marketing efforts is very difficult.`,
    component: GettingStarted,
  },
  {
    slug: `developing`,
    heading: `Developing`,
    summary: `You collect data reliably, understand it, and act on it.`,
    description: `You have seen the power of customer data and the insights it can provide. You’ve implemented tools to collect customer data and put that data to use, but the process breaks down when you try to build holistic customer profiles and take actions based on those profiles. As a result, you may have higher customer acquisition costs and lower customer lifetime value because of poor experiences.`,
    component: Developing,
  },
  {
    slug: `leading`,
    heading: `Leading`,
    summary: `Data drives your KPIs and growth strategy.`,
    description: `Customer data is an important part of your strategy and you can consistently answer questions about your customers. However, you may not have fully operationalized your customer data in a way that enables you to deliver personalized and timely content.`,
    component: Leading,
  },
  {
    slug: `visionary`,
    heading: `Visionary`,
    summary: `You lead your category with data-driven user experiences.`,
    description: `You differentiate based on your user experience. Customers consistently turn to you because you provide a personalized experience, useful experience. You can easily use your customer data in the tools you need to run your business, which makes your company extremely adaptable to change.`,
    component: Visionary,
  },
]

export default data
